import { defineStore } from 'pinia'

interface LoginState {
  phone: string
  countryCode: string
  isRegistered: boolean | null
  otpToken: string
  pin: string
  confirmPin: string
}

export const useLoginStore = defineStore('login', {
  state: (): LoginState => ({
    phone: '',
    countryCode: '',
    isRegistered: false,
    otpToken: '',
    pin: '',
    confirmPin: ''
  }),
  actions: {
    setLoginData(
      data: Partial<{
        phone: string
        countryCode: string
        isRegistered: boolean | null
        otpToken: string
        pin: string
        confirmPin: string
      }>
    ) {
      if (data.phone !== undefined) this.phone = data.phone
      if (data.countryCode !== undefined) this.countryCode = data.countryCode
      if (data.isRegistered !== undefined) this.isRegistered = data.isRegistered
      if (data.otpToken !== undefined) this.otpToken = data.otpToken
      if (data.pin !== undefined) this.pin = data.pin
      if (data.confirmPin !== undefined) this.confirmPin = data.confirmPin
    },
    setIsRegistered(val: boolean | null) {
      this.isRegistered = val
    },
    setOtpToken(token: string) {
      this.otpToken = token
    },
    setPin(pin: string) {
      this.pin = pin
    },
    setConfirmPin(confirmPin: string) {
      this.confirmPin = confirmPin
    },
    resetLoginData() {
      this.phone = ''
      this.countryCode = ''
      this.isRegistered = null
      this.otpToken = ''
      this.pin = ''
      this.confirmPin = ''
    }
  }
})
